import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import BookFormField from "./BookFormField";
import StoreBookFormModal from "./storeBookFormModal";
import { useUserContext } from "@overrides_venia/peregrine/context/user";
const StoreBookFormField = _ref => {
  var _currentUser$lsAccoun, _currentUser$lsAccoun2, _currentUser$lsAccoun3;
  let {
    selectedStore,
    setSelectedStore,
    allStores,
    isModalSelectionOpen,
    setIsModalSelectionOpen,
    backgroundClass,
    borderClass,
    showStoreHours,
    disabled,
    minimalView,
    hidden,
    label,
    enableSwissOrderRedirect = false,
    applySelectedClasses = false,
    fieldTextWhenEmpty = "where"
  } = _ref;
  const {
    formatMessage
  } = useIntl();
  const [{
    currentUser
  }] = useUserContext();
  const favouriteStore = currentUser === null || currentUser === void 0 ? void 0 : (_currentUser$lsAccoun = currentUser.lsAccount) === null || _currentUser$lsAccoun === void 0 ? void 0 : (_currentUser$lsAccoun2 = _currentUser$lsAccoun.customer_attributes) === null || _currentUser$lsAccoun2 === void 0 ? void 0 : (_currentUser$lsAccoun3 = _currentUser$lsAccoun2.find(x => x.id === "FAV_STORE")) === null || _currentUser$lsAccoun3 === void 0 ? void 0 : _currentUser$lsAccoun3.value;
  useEffect(() => {
    if (favouriteStore && allStores !== null && allStores !== void 0 && allStores.length && !selectedStore) {
      const store = allStores.find(x => x.id === favouriteStore);
      if (store) {
        setSelectedStore(store);
      }
    }
  }, [favouriteStore, allStores]);
  return /*#__PURE__*/React.createElement(BookFormField, {
    fieldLabel: label,
    fieldIcon: "icon-locator",
    fieldImg: selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.store_preview_image_mobile,
    fieldId: "store",
    fieldTextWhenEmpty: formatMessage({
      id: fieldTextWhenEmpty
    }),
    backgroundClass: backgroundClass,
    borderClass: borderClass,
    fieldSelected: selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.frontend_name,
    applySelectedClasses: applySelectedClasses,
    fieldSelectedSecondaryInfo: selectedStore ? selectedStore.address.address1 + "," + selectedStore.address.city : null,
    openModal: () => setIsModalSelectionOpen(true),
    disabled: disabled,
    minimalView: minimalView,
    hidden: hidden,
    modalComponent: StoreBookFormModal,
    modalProps: {
      setSelectedStore,
      isModalSelectionOpen,
      setIsModalSelectionOpen,
      allStores,
      showStoreHours,
      enableSwissOrderRedirect
    }
  });
};
export default StoreBookFormField;